import React, { useEffect, useState } from 'react';
import { Modal, Input, Button, Space, Tag, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { COUPON_LANGS, countI18n } from '../couponData';

const { Text } = Typography;

/**
 * 卡券名称 - 多语言配置弹窗
 * 用法：
 *   列表页快捷修改：<CouponNameI18nModal open name={record.name} i18n={record.i18n} onSave={fn} onCancel={fn} />
 *   新建/编辑：     <CouponNameI18nModal open name={表单名称} i18n={暂存译文} onSave={fn} onCancel={fn} />
 * onSave(nextI18n)：返回仅含已填写译文的 { 'en-US': '...' } 对象
 */
const CouponNameI18nModal = ({ open, name, i18n, onCancel, onSave }) => {
  const [values, setValues] = useState({});

  // 每次打开按当前已配置译文回显（切换不同卡券时重新初始化）
  useEffect(() => {
    setValues(open && i18n ? { ...i18n } : {});
  }, [open, i18n]);

  const configured = countI18n(values);

  const handleOk = () => {
    const cleaned = {};
    COUPON_LANGS.forEach((lang) => {
      const v = values[lang.key];
      if (v && String(v).trim()) cleaned[lang.key] = String(v).trim();
    });
    onSave(cleaned);
  };

  return (
    <Modal
      title={(
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <GlobalOutlined style={{ color: '#1890ff' }} />
          <span>卡券名称 — 多语言翻译</span>
          <Tag color={configured === COUPON_LANGS.length ? 'success' : 'default'} style={{ marginLeft: 4 }}>
            已配置 {configured}/{COUPON_LANGS.length}
          </Tag>
        </div>
      )}
      open={open}
      onCancel={onCancel}
      width={820}
      zIndex={1200}
      destroyOnClose
      styles={{ body: { maxHeight: 560, overflowY: 'auto', padding: '12px 24px' } }}
      footer={(
        <Space>
          <Button onClick={onCancel}>取消</Button>
          <Button type="primary" onClick={handleOk}>保存</Button>
        </Space>
      )}
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 13, color: '#666' }}>默认展示名称（中文）：</div>
        <div style={{
          padding: '10px 16px', background: '#f5f5f5', borderRadius: 6,
          color: '#333', fontSize: 13, border: '1px solid #eee',
        }}>
          {name || '请先填写卡券名称'}
        </div>
      </div>

      <div style={{ marginBottom: 12, color: '#999', fontSize: 12 }}>
        译文用于 App / C 端按语言展示券名称，未配置的语言回落展示中文名称。
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px 24px' }}>
        {COUPON_LANGS.map((lang) => {
          const filled = values[lang.key] && String(values[lang.key]).trim();
          return (
            <div key={lang.key}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <span style={{ fontWeight: 500, fontSize: 13 }}>
                  {lang.label}
                  <Tag color={filled ? 'success' : 'default'} style={{ marginLeft: 6, marginRight: 0 }}>
                    {filled ? '已配置' : '未配置'}
                  </Tag>
                </span>
                <Text type="secondary" style={{ fontSize: 12 }}>{lang.key}</Text>
              </div>
              <Input.TextArea
                rows={2}
                maxLength={50}
                showCount
                placeholder={`请输入${lang.label}译文`}
                style={{ borderRadius: 6, resize: 'none' }}
                value={values[lang.key] || ''}
                onChange={(e) => setValues((prev) => ({ ...prev, [lang.key]: e.target.value }))}
              />
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default CouponNameI18nModal;
